//Account Action Types
export const LOAD_ACCOUNTS_SUCCESS = 'LOAD_ACCOUNTS_SUCCESS';
export const LOAD_ACCOUNTS_FAILED = 'LOAD_ACCOUNTS_FAILED';
export const SET_CURRENT_ACCOUNT = 'SET_CURRENT_ACCOUNT';
export const UPDATE_CURRENT_ACCOUNT = 'UPDATE_CURRENT_ACCOUNT';
export const PAID_ACCCOUNT = 'PAID_ACCCOUNT';
export const IS_IE = 'IS_IE';

//UI Action Types
export const ENABLE_LOADER = 'ENABLE_LOADER';
export const DISABLE_LOADER = 'DISABLE_LOADER';
export const DISABLE_LOADER_WITH_ERROR = 'DISABLE_LOADER_WITH_ERROR';
export const SHOW_PAYMODAL = 'SHOW_PAYMODAL';
export const HIDE_PAYMODAL = 'HIDE_PAYMODAL';
export const DISABLE_PAYMODAL = 'DISABLE_PAYMODAL';
export const ENABLE_PAYMODAL = 'ENABLE_PAYMODAL';
export const SHOW_PAYVEIL = 'SHOE_PAYVEIL';
export const HIDE_PAYVEIL = 'HIDE_PAYVEIL';


//Payment Actions
export const CAPTURE_TRANSACTION_INFO = 'CAPTURE_TRANSACTION_INFO'

//Application experience Actions
export const RESET_STORE = 'RESET_STORE';



// WEBPACK FOOTER //
// ./src/actions/actionType.js